import React from 'react';
import { ConfirmationDialog, ErpDataTableV2 } from '@/components/custom/erp';
import { getDataTableColumns } from './cols-definition';
import { ActionBar, FormDialog } from './components';
import { Tax, TaxInput } from '@/types/schemas';
import { useCRUD, useForms } from '@/hooks';
import { toast } from '@/hooks/use-toast';
import { QUERY_KEYS } from '@/constants';

export default function DanhMucThueSuatPage() {
  const { addItem, updateItem, deleteItem, refreshData, isLoading, data, fetchDetail } = useCRUD<Tax, TaxInput>({
    endpoint: QUERY_KEYS.THUE
  });

  const {
    showForm,
    showDelete,
    selectedObj,
    selectedRowIndex,
    formMode: mode,
    isCopyMode,

    handleCloseForm,
    handleCloseDelete,
    handleAddClick,
    handleEditClick,
    handleViewClick,
    handleDeleteClick,
    handleCopyClick,
    handleRowClick,
    clearSelection
  } = useForms<Tax>(fetchDetail);

  const handleSubmit = async (data: TaxInput) => {
    try {
      if (mode === 'add') {
        await addItem(data);
      } else if (mode === 'edit' && selectedObj) {
        await updateItem(selectedObj.uuid, data);
      }
      handleCloseForm();
      clearSelection();
    } catch (err: unknown) {
      toast({
        description: 'Không thể lưu dữ liệu thuế suất.',
        variant: 'destructive'
      });
    }
  };

  const tables = [
    {
      name: '',
      rows: data,
      columns: getDataTableColumns()
    }
  ];
  return (
    <div className='flex h-full min-h-screen w-full min-w-0 max-w-full flex-col lg:overflow-hidden'>
      {showForm && (
        <FormDialog
          mode={mode}
          onClose={handleCloseForm}
          onAdd={handleAddClick}
          onEdit={handleEditClick}
          onCopy={handleCopyClick}
          onDelete={handleDeleteClick}
          onSubmit={handleSubmit}
          initialData={mode === 'add' && !isCopyMode ? undefined : selectedObj}
        />
      )}

      <div className='w-full'>
        <ActionBar
          onAddClick={handleAddClick}
          onEditClick={handleEditClick}
          onDeleteClick={handleDeleteClick}
          onCopyClick={handleCopyClick}
          onViewClick={handleViewClick}
          onRefreshClick={refreshData}
        />

        <ErpDataTableV2
          tables={tables}
          selectedRowId={selectedRowIndex || undefined}
          onRowClick={handleRowClick}
          loading={isLoading}
        />
      </div>

      {showDelete && (
        <ConfirmationDialog
          onClose={handleCloseDelete}
          onConfirm={async () => {
            try {
              await deleteItem(selectedObj!.uuid);
              handleCloseDelete();
              clearSelection();
              handleCloseForm();
            } catch (err: unknown) {
              toast({
                description: 'Không thể xóa dữ liệu thuế suất.',
                variant: 'destructive'
              });
            }
          }}
        />
      )}
    </div>
  );
}
